import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, first, of } from 'rxjs';

import { KeyTemplate } from '../../models';
import { QuestInstanceService } from '../../services';

export const keyTemplatesResolver: ResolveFn<KeyTemplate[] | null> = (route) => {
  const questInstanceService: QuestInstanceService = inject(QuestInstanceService);

  const questInstanceId = route.parent?.parent?.paramMap.get('questInstanceId');
  const parentId = route.queryParamMap.get('parentId');

  if (!questInstanceId || !parentId) {
    return null;
  }

  return questInstanceService.getQuestInstanceKeyTemplatesByParentId(questInstanceId, parentId).pipe(
    first(),
    catchError(() => of(null)),
  );
};
